<template>
  <div class="box" @touchmove="preLoad(getPre)" ref="comWrapper">
    <p class="comNum" :style="{ color: compnentColor }">
      <span>讨论区({{ commentObj.commentCount }})</span>
    </p>
    <div
      class="comBigCover"
      @touchmove.prevent
      v-show="showReply"
      @click="showReply = false"
    >
      <div class="comFirstFrom" @click.stop>
        <textarea
          @click.stop
          @focus="focusEvent"
          ref="comFirstText"
          class="comFirstText"
          v-model.trim="replyValue"
          placeholder="说点什么..."
        ></textarea>
        <button
          :disabled="replyValue ? false : true"
          :class="[replyValue ? '' : 'cant', 'comFirstBt']"
          @click="sendReply"
        >
          提交
        </button>
      </div>
    </div>
    <div
      class="comment_input_box"
      v-show="!showReply"
      :style="{ width: compnentColor != '#000' ? '1.3rem' : '2.6933rem' }"
    >
      <!--<input class="showContent" type="text" placeholder="向讲师提问" readonly="readonly">-->
      <!--<div class="showContent">-->
      <!--提问-->
      <!--</div>-->
      <img
        @click="clickRelease"
        class="showContent"
        src="http://cdn.yxvzb.com/newWechat/image/%E8%AF%84%E8%AE%BA@2x.png"
        alt=""
      />
      <img
        v-if="compnentColor == '#000'"
        @click="collection"
        class="collection"
        :src="
          isCollection
            ? 'http://cdn.yxvzb.com/newWechat/image/%E4%B8%AA%E4%BA%BA%E4%B8%AD%E5%BF%83-%E6%88%91%E7%9A%84%E6%94%B6%E8%97%8F@2x.png'
            : 'http://cdn.yxvzb.com/newWechat/image/%E6%94%B6%E8%97%8F@2x.png'
        "
        alt=""
      />
    </div>
    <ul :class="[compnentColor != '#000' ? 'whiteFontColor' : '']">
      <li
        @click="audioPlay($event)"
        class="comConLi"
        v-for="(item, index) in commentObj.list"
        :key="index"
      >
        <img :src="item.headPhoto" class="comUserPh" />
        <div class="comUserCon">
          <div class="comUserNZ">
            <span v-if="item.replyIsAuth" class="comUserName hasReplyIsAuth">
              {{ item.replyUserName }}
            </span>
            <span v-else class="comUserName">{{ item.replyUserName }}</span>
            <span
              :style="{
                right: wxUserInfo.id == item.userId ? '.6rem' : '2rem'
              }"
              :class="[
                item.isLike == '1' ? 'comUserZan2' : 'comUserZan',
                'zanBts',
                'ZanHasRight'
              ]"
              @click="like(item)"
            >
              {{ item.likeCount }}
            </span>

            <span class="createTimes">
              {{ item.createTime | transMonthLine }}
            </span>
            <div class="comTM newComTM" v-if="wxUserInfo.id != item.userId">
              <div class="comSH newComSH" v-show="showMore.index == index">
                <!--data-id  questionId 回复-->
                <span class="comReply" @click="clickReplay(item)">回复</span>
                <!--data-id 删除-->
                <!-- <span class="comRemove" v-if="wxUserInfo.id == item.userId"
                      @click="selfDelete(item,index)">删除</span> -->
                <span class="comRemove" @click="accusation(item)">举报</span>
              </div>
              <span class="comMore" @click="showMoreFunc(item, index)"></span>
            </div>
          </div>
          <div @click="" class="comCT" v-if="item.replyVoiceTime">
            <div
              class="audioDiv"
              v-if="!item.beReplyUserName && !item.beReplyUserId"
            >
              <div class="voice-animate">
                <div class="small"></div>
                <div class="middle"></div>
                <div class="large"></div>
              </div>
              <div>{{ item.replyVoiceTime }}</div>
              <audio :src="item.replyMediaId"></audio>
            </div>
            <div v-else>
              <span>回复</span>
              <span class="comCTN">@{{ item.beReplyUserName }}</span>
              <span>:</span>
              <div @click="" class="audioDiv">
                <div class="voice-animate">
                  <div class="small"></div>
                  <div class="middle"></div>
                  <div class="large"></div>
                </div>
                <div>{{ item.replyVoiceTime }}</div>
                <audio :src="item.replyMediaId"></audio>
              </div>
              <div
                v-if="item.beReplayIsDelete == 1"
                class="comCTF comRemoveDiv"
                style="color: #CC3333;text-align: center"
              >
                此评论已删除
              </div>
              <div v-else>
                <div
                  class="comCTF"
                  v-if="!item.beReplyVoiceTime && !item.beReplyMediaId"
                >
                  <span class="comCTN">@{{ item.beReplyUserName }}</span>
                  :{{ item.beReplyContent }}
                </div>
                <div @click="" class="comCTF" v-else>
                  <span class="comCTN">@{{ item.beReplyUserName }}</span>
                  :
                  <div class="audioDiv">
                    <div class="voice-animate">
                      <div class="small"></div>
                      <div class="middle"></div>
                      <div class="large"></div>
                    </div>
                    <div>{{ item.beReplyVoiceTime }}</div>
                    <audio :src="item.beReplyMediaId"></audio>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="comCT" v-else>
            <span v-if="!item.beReplyUserName && !item.beReplyUserId">
              {{ item.content }}
            </span>
            <div v-else>
              <span class="comCTN">@{{ item.beReplyUserName }}</span>
              :{{ item.content }}
              <div
                v-if="item.beReplyDelFlag == 1"
                class="comCTF comRemoveDiv"
                style="color: #CC3333;text-align: center"
              >
                此评论已删除
              </div>
              <div v-else>
                <div
                  class="comCTF"
                  v-if="!item.beReplyVoiceTime && !item.beReplyMediaId"
                >
                  <span class="comCTN">@{{ item.beReplyUserName }}:</span>
                  <span>{{ item.beReplyContent }}</span>
                </div>
                <div @click="" class="comCTF" v-else>
                  <span class="comCTN">@{{ item.beReplyUserName }}</span>
                  :
                  <div class="audioDiv">
                    <div class="voice-animate">
                      <div class="small"></div>
                      <div class="middle"></div>
                      <div class="large"></div>
                    </div>
                    <div>{{ item.beReplyVoiceTime }}</div>
                    <audio :src="item.beReplyMediaId"></audio>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>
<script>
import index from './comment';
export default index;
</script>
<style lang="less" scoped="">
@import './comment.less';
</style>
